import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Summary } from '../types';

@Component({
  selector: 'dashboard-invoicing-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class DashboardInvoicingSummaryComponent implements OnInit {
  @Input() data: Summary

  constructor(private Router: Router) { }

  ngOnInit(): void {
  }
  toInvoiceable() {
    this.Router.navigateByUrl('invoicing/invoiceable-receipts')
  }
}
